import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "grid-sizer" }, null, -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "alt"]

import Masonry from 'masonry-layout';
import {onMounted, ref, onBeforeUnmount} from 'vue';
import imagesLoaded from 'imagesloaded';
import Lightbox from './Lightbox.vue';

interface Image {
  url: string;
  focalPoint: { x: number; y: number } | null;
  public: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Masonry',
  props: {
    images: {}
  },
  setup(__props: any) {

const props = __props;


let masonry: Masonry | null = null;

const grid = ref<HTMLElement | null>(null);

const lightboxVisible = ref(false);
const currentIndex = ref(0);

onMounted(() => {
  initializeMasonry();
})


const initializeMasonry = () => {
  if (grid.value) {
    masonry = new Masonry(grid.value, {
      itemSelector: '.masonry-item',
      columnWidth: '.grid-sizer',
      percentPosition: true,
    });
 
   imagesLoaded(grid.value).on('progress', () => {
      if (masonry) {
        masonry.layout();
      }
    });
  }
}

onBeforeUnmount(() => {
  if (masonry) {
    masonry.destroy();
    masonry = null;
  }
})

const openLightbox = (index: number) => {
  currentIndex.value = index;
  lightboxVisible.value = true;
}

const closeLightbox = () => {
  lightboxVisible.value = false;
}

const nextImage = () => {
  if (currentIndex.value < props.images.length - 1) {
    currentIndex.value++;
  }
}

const prevImage = () => {
  if (currentIndex.value > 0) {
    currentIndex.value--;
  }
}





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "masonry-grid w-full flex mx-auto",
      ref_key: "grid",
      ref: grid
    }, [
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "masonry-item p-[0.2rem] cursor-pointer",
          onClick: ($event: any) => (openLightbox(index))
        }, [
          _createElementVNode("img", {
            class: "rounded-md",
            src: image.url,
            alt: `Image ${index + 1}`
          }, null, 8, _hoisted_4)
        ], 8, _hoisted_3))
      }), 128))
    ], 512),
    _createVNode(Lightbox, {
      visible: lightboxVisible.value,
      images: _ctx.images,
      currentIndex: currentIndex.value,
      onClose: closeLightbox,
      onNext: nextImage,
      onPrev: prevImage
    }, null, 8, ["visible", "images", "currentIndex"])
  ]))
}
}

})